function getAgeOptions(min, max) {
  return new Array(max - min + 1).fill(0).map((x, i) => i + min).map(value => ({
    label: String(value),
    value
  }))
}

module.exports = {
  type: 'form',
  id: 'masterdata',
  icon: 'align-justify',
  title: {
    de: 'Stammdaten',
    en: 'Master data'
  },
  intro: require('./Construction-Intro.html'),
  outro: '',
  form: [
    {
      id: 'name',
      type: 'text',
      label: {
        de: 'Auftrags-ID',
        en: 'Order ID'
      }
    },
    {
      id: 'description',
      type: 'multi',
      label: {
        de: 'Konstruktionsanweisung',
        en: 'Construction hint'
      }
    },
    {

      id: 'productSelection',
      type: 'finder',
      label: {
        de: 'Produkt selektion',
        en: 'Product selection',
      },
      productTree: require('./ProductTree.js'),
    },
    {
      id: 'xmlNumber',
      type: 'text',
      label: {
        de: 'XML-Nummer',
        en: 'XML Number'
      }
    },
  ]
}
